/**
 * @generated SignedSource<<39934b324d6fe57226548de0d3001440>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedAboutItemPanel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarSoldItems_viewer" | "useShouldShowSimilarSoldItems_viewer" | "useSimilarSoldItemsTracking_viewer">;
  readonly " $fragmentType": "PdpRespSharedAboutItemPanel_viewer";
};
export type PdpRespSharedAboutItemPanel_viewer$key = {
  readonly " $data"?: PdpRespSharedAboutItemPanel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedAboutItemPanel_viewer",
  "selections": [
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItems_viewer"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarSoldItemsTracking_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "37e829dd66a8187700c431f473029499";

export default node;
